import { useLocale } from './useLocale';
import { useTranslationStatus } from './useTranslationStatus';
import { translationsConfig } from '../../sources';
export const useTranslationsReady = () => {
    const { locale } = useLocale();
    const { loadedLocale } = useTranslationStatus();
    // the loading of translations is deemed ready if the translations are loaded or the locale is not supported
    return locale === loadedLocale || translationsConfig[locale] === undefined;
};
//# sourceMappingURL=useTranslationsReady.js.map